const HtmlRestartWindow = {
    show: function (options) {
        let overlay = document.getElementById("htmlRestartWindow");
        if (!overlay) {
            overlay = document.createElement("div");
            overlay.id = "htmlRestartWindow";
            document.body.appendChild(overlay);
        }
        overlay.innerHTML = "";

        const content = document.createElement("div");
        overlay.appendChild(content);

        const messages = options.messages;

        const title = document.createElement("h1");
        title.textContent = Messages.has(messages.title) || messages.titleFallback;
        content.appendChild(title);

        const description = document.createElement("p");
        description.textContent = Messages.has(messages.description) || messages.descriptionFallback;
        content.appendChild(description);

        if (options.retryDelay) {
            const countdown = document.createElement("p");
            countdown.className = "retry";
            content.appendChild(countdown);

            const deadline = Date.now() + options.retryDelay;
            const tick = () => {
                const seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
                countdown.textContent = Messages.replace(Messages.has("RestartWindow.Countdown") || "Retrying in %{seconds} s…", { seconds });
                if (seconds > 0) {
                    setTimeout(tick, 1000);
                }
            };
            tick();
        }

        const button = document.createElement("button");
        if (options.onRetry) {
            button.textContent = Messages.has("RestartWindow.Retry") || "Try again";
            button.onclick = () => {
                document.body.removeChild(overlay);
                options.onRetry();
            };
        } else {
            button.textContent = Messages.has("RestartWindow.Reload") || "Reload";
            button.onclick = options.onReload || (() => ErrorHandler.reload());
        }
        content.appendChild(button);
    }
};
